import router from './router'

router.beforeEach((to, from, next)=>{
    const hasToken = sessionStorage.getItem('token')
    const level = sessionStorage.getItem('level')
    if(to.path == '/login'){
        next()
    }else{
        if(hasToken){
            if (level !=0 && sessionStorage.getItem('login_count') == 0 && sessionStorage.getItem('has_update_password') != 1 && to.path != '/editPassword') {
                next({path: '/editPassword'})
            } else {
                next()
            }
            // next()

        }else{
            next({path:'/login'})
        }
    }

    if(to.matched.length == 0){
        next({path:'/'})
    }
})
